import { Emitter } from "pixi-particles";

class ParticleLoop {

    protected emitters: Map<string, Emitter>;
    protected lastUpdateTime:number;

    public add( emitterName: string, emitter: Emitter) {
        if (!this.emitters) {
            this.emitters = new Map<string, Emitter>();
        }

        this.remove(emitterName);
        this.emitters.set(emitterName, emitter);
        emitter.addAtBack = true;
        emitter.emit = true;
    }

    public remove(emitterName) {
        if (this.emitters.has(emitterName)) {
            let old = this.emitters.get(emitterName);
            old.emit = false;
            old.cleanup();
            old.destroy();
            this.emitters.delete(emitterName);
        }
    }

    public update(time: number) {
        if (this.lastUpdateTime && this.emitters) {
            this.emitters.forEach((emitter) => {
                // console.log(time * 0.001 , time);
                emitter.update((time * 0.01 ))
            });
        }
        this.lastUpdateTime = time;
    }

}

export default new ParticleLoop();
